<div class="flex items-center">
    <p-checkbox
        binary="true"
        [(ngModel)]="rateChangeOnly"
        (ngModelChange)="RateChangeOnlyChanged.next(rateChangeOnly)"
    ></p-checkbox>
    <label class="ml-2">Display row only when a rate has changed</label>
</div>
<div class="rate-history-table">
    <p-table stripedRows #dataTable
        [value]="items"
        dataKey="id"
        editMode="row"
        [scrollable]="true"
        scrollHeight="flex"
        [loading]="loading"
        [columns]="cols"
        sortMode="single"
        (sortFunction)="customSort($event)"
        [customSort]="true"
    >
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="numCols" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr>
                <td [attr.colspan]="numCols" style="text-align: center">
                    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item let-columns>
            <tr>
                <th class="colgroup" colspan="3">Period Information</th>
                <!-- dynamic -->
                <th class="colgroup" [attr.id]="col.field" *ngFor="let col of colGroups" [attr.colspan]="col.colspan">
                    {{ col.group | uppercase }}
                    {{ col.header | uppercase }}
                </th>
            </tr>
            <!-- column headers -->
            <tr>
                <th pSortableColumn="periodstart">
                    Period Start
                    <p-sortIcon
                        field="periodstart"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <th pSortableColumn="periodend">
                    Period End
                    <p-sortIcon
                        field="periodend"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <th pSortableColumn="periodstatus">
                    Period Type
                    <p-sortIcon
                        field="periodstatus"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- <th>Process Date</th> -->
                <!-- <th>Period Status</th> -->
                <!-- dynamic -->
                <th
                    *ngFor="let col of columns"
                    [style]="col.style"
                    pSortableColumn="{{ col.group }}-{{ col.field }}">
                    {{ col.header }}
                    <p-sortIcon
                        field="{{ col.group }}-{{ col.field }}"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-item
            let-edit="editing"
            let-ri="rowIndex"
            let-columns="columns"
        >
            <tr data-id="row-{{ item.id }}"
                [pSelectableRow]="item"
                [pEditableRow]="item"
            >
                <td>
                    {{ item.periodstart | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                    {{ item.periodend | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                    {{ item.periodstatus }}
                </td>
                <!-- dynamic -->
                <td *ngFor="let col of columns">
                    {{ item[col.group][col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
